import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { SubscriptionBundlesVM } from '../../../viewModel/subscriptionBundles.viewModel';
import { footerWrapper, stepsWrapper } from './MigrationModal.css';
import { ExclusiveSubscriptionInfo } from './steps/ExclusiveSubscription';
import { Confirmation } from './steps/Confirmation';
import { Price } from '../../form/Price';
import { clsx } from 'clsx';
import { Recommendation } from './steps/Recommendation';
import { HowItWorks } from './steps/HowItWorks';

export type MigrationModalProps =
  SubscriptionBundlesVM['migrateToBundle']['migrationModal'] & {
    dispatch: SubscriptionBundlesVM['dispatch'];
  };

export const MigrationModal: React.FC<MigrationModalProps> = ({
  isOpen,
  close,
  ...p
}) => (
  <Modal
    isOpen={isOpen}
    onClose={close}
    modalClassName="w-full lg:w-[1120px] h-[100%] md:h-[800px] flex flex-col justify-between"
    disableBackdropClick={true}
    footer={<Footer stepCta={p.stepCta} />}
  >
    <div className={stepsWrapper}>
      <Step {...p} />
    </div>
  </Modal>
);

const Step = ({
  step,
  ...p
}: Pick<
  MigrationModalProps,
  'step' | 'control' | 'transformPrice' | 'price' | 'error' | 'dispatch'
>) => {
  switch (step) {
    case 1:
      return <ExclusiveSubscriptionInfo />;
    case 2:
      return <HowItWorks />;
    case 3:
      return <Recommendation dispatch={p.dispatch} />;
    case 4:
      return <Price {...p} />;
    case 5:
      return <Confirmation dispatch={p.dispatch} />;
  }
};

const Footer: React.FC<Pick<MigrationModalProps, 'stepCta'>> = ({
  stepCta,
}) => (
  <div className={footerWrapper}>
    {stepCta.map(
      ({ title, onClick, variant, submitting, className, color }) => (
        <Button
          key={title}
          color={color || 'neutral'}
          onClick={onClick}
          variant={variant || 'filled'}
          disabled={submitting}
          loading={submitting}
          className={clsx(className)}
        >
          {title}
        </Button>
      ),
    )}
  </div>
);
